import React, { useState } from 'react';
import { FinalFormField } from 'components';
import { useForm } from 'react-final-form-hooks';
import validator, { isRequired, isEmail } from 'lib/utils/validator';

export default ({ onLoginSubmit, onForgotPasswordSubmit }) => {
  const [isForgotPassword, setIsForgotPassword] = useState(false);

  const formSwitcher = (e) => {
    e.preventDefault();
    setIsForgotPassword((prevState) => !prevState);
  };

  const { form: forgotPasswordForm, handleSubmit: handleForgotPasswordSubmit } = useForm({
    onSubmit: onForgotPasswordSubmit,
    validate: (data) => validator(data, {
      email: [isRequired(), isEmail('Email is not valid')],
    }),
  });

  const { form: loginForm, handleSubmit: handleLoginSubmit } = useForm({
    onSubmit: onLoginSubmit,
    validate: (data) => validator(data, {
      email: [isRequired(), isEmail('Email is not valid')],
      password: [isRequired()],
    }),
  });
  return (
    <div>
      {isForgotPassword ? (
        <form onSubmit={handleForgotPasswordSubmit}>
          <FinalFormField form={forgotPasswordForm} autoFocus label="Email" name="email" type="email" />
          <button type="submit" className="btn-yellow fullwidth mt-2">Reset Password</button>
          <div className="small ml-1 mt-2 pointer width-fitContent" onClick={formSwitcher}>Back To Login</div>
        </form>
      )
        : (
          <form onSubmit={handleLoginSubmit}>
            <FinalFormField form={loginForm} autoFocus label="Email" name="email" type="email" />
            <FinalFormField form={loginForm} label="Password" name="password" type="password" />
            <button type="submit" className="btn-yellow fullwidth mt-2">Login</button>
            <div className="small ml-1 mt-2 pointer width-fitContent" onClick={formSwitcher}>Forgot Password</div>
          </form>
        )}
    </div>
  );
};
